export default __webpack_public_path__ + "static/media/dao-bg@1x.9239280d.webp";